//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import TableComponentServerSingleWithFilter from '../../components/TableComponent/TableComponentServerSingleWithFilter.vue'
import TableCellObject from '../../components/Table/TableCellObject.vue'

export default {
  name: 'ItemsSearchField',
  components: {
    TableComponentServerSingleWithFilter,
    TableCellObject
  },
  props: {
    label: {
      type: String,
      default () {
        return ''
      }
    },
    labelColor: {
      type: String,
      default: 'black' // 'grey-9'
    },
    placeholder: {
      type: String,
      default () {
        return ''
      }
    },
    selectionDialogLabel: {
      type: String,
      default: null
    },
    selectionDialogColumns: {
      type: Array,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    optionValue: {
      type: String,
      default: 'id'
    },
    optionLabel: {
      type: String,
      default: 'name'
    },
    dense: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    hideHint: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Object, Array],
      default: null
    },
    singleModelObject: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    emitValue: {
      type: Boolean,
      default: false
    },
    autoUpdate: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: null
    },
    /**
     * Показывать ли кнопку очистки значения всегда, когда есть значение. Если false, то будет отображаться лишь при фокусировке на поле
     */
    clearable: {
      type: Boolean,
      default: false
    },
    /**
     * Показывать ли кнопку очистки значения. Если true, то НЕ будет отображаться вне зависимости от clearable.
     */
    notClearable: {
      type: Boolean,
      default: false
    },
    searchConfig: {
      type: Object,
      required: true
    },
    selectDisabled: {
      type: Boolean,
      default: false
    },
    tableDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Отображение
     */
    columnView: {
      type: Boolean,
      default: false
    },
    displayKeysInTable: {
      type: Boolean,
      default: false
    },
    useChipsAlways: {
      type: Boolean,
      default: false
    },
    confirmSaveSelection: {
      type: Object,
      default: null
    },
    allowBackspace: {
      type: Boolean,
      default: false
    },
    tableEnableSearchFieldModes: {
      type: Boolean,
      default: false
    },
    optionDisable: {
      type: Function,
      default: opt => opt._disabled
    }
  },
  data: function () {
    return {
      searchValue: false,
      selectionDialogOpened: false,
      selectedItems: [],
      selectedItemsIds: [],
      ignoreInputChange: false,
      ignoreNextNativeClickEvent: false,
      popupWidth: '',
      inputValue: ''
    }
  },
  computed: {
    itemsList: function () {
      if (!this.multiple && this.singleModelObject) {
        return this.value ? [this.value] : []
      }
      return this.value || []
    },
    itemsText: function () {
      if (this.itemsList && this.itemsList.length) {
        const separator = this.columnView ? '<br/>' : ', '
        return this.itemsList.map(item => this.getItemLabel(item)).join(separator)
      }
      return null
    },
    defaultRule: function () {
      // console.log('default rule: ', this.label)
      if (!this.readonly) {
        return !this.required || this.itemsList.length !== 0
      }
      return true
    },
    selectionLabel: function () {
      return this.selectionDialogLabel ? this.selectionDialogLabel : this.multiple ? 'ВЫБОР ЗНАЧЕНИЙ' : 'ВЫБОР ЗНАЧЕНИЯ'
    },
    searchResultInfo: function () {
      const options = this.searchConfig.optionsFiltered
      const store = this.searchConfig.store
      if (store && store.itemsTotal) {
        if (options && options.length < store.itemsTotal) {
          return {
            itemsShown: options.length,
            itemsTotal: store.itemsTotal
          }
        }
      }
      return null
    },
    useChips: function () {
      return this.useChipsAlways || this.multiple && this.searchConfig.focus
    }
  },
  watch: {
    required: function () {
      this.resetValidation()
    }
  },
  methods: {
    getItemValue (item) {
      return this.emitValue ? item : item[this.optionValue]
    },
    getItemLabel (item) {
      return this.emitValue ? item : item[this.optionLabel]
    },
    onShowPopup: function (event) {
      this.$nextTick(() => {
        // const menu = document.querySelector('.q-menu')
        // const menuCmp = menu.__vue__.$parent.$parent
        // menuCmp.maxHeight = '250px' // .$props

        this.popupWidth = this.$refs.select.$el.offsetWidth
        this.$refs.select.scrollTo(0)
      })
    },
    onInputChange: function (value) {
      // Сброс сохраненного значения внутреннего input
      this.inputValue = ''

      if (!this.ignoreInputChange) {
        if (this.multiple) {
          this.setValue(value)
        } else {
          value = value.length ? [value[value.length - 1]] : []
          this.setValue(value)

          if (value.length) {
            this.$nextTick(() => {
              if (this.$refs.select) { // После изменения значения может пропасть при перерисовке (?) внешнего компонента
                this.$refs.select.hidePopup()
              }
              this.$nextTick(() => {
                this.hideSearchInput()
              })
            })
          }
        }
      }
    },
    onInputValueChange: function (value) {
      this.inputValue = value
    },
    setValue: function (value) {
      if (!this.multiple && this.singleModelObject) {
        value = value && value.length ? value[0] : null
      }
      this.$emit('input', value)
      // this.$emit('update:value', value)
    },
    validate: function () {
      return this.$refs.select.validate()
    },
    resetValidation: function () {
      this.$refs.select.resetValidation()
    },
    hardResetValidation: function () {
      this.resetValidation()
      this.$refs.select.__initDirty()
      this.$refs.select.__triggerValidation()
    },
    onBackspaceKeyDown: function () {
      // Если не проигнорировать событие, то будет удалено последнее значение из списка, если поле ввода пустое
      if (!this.allowBackspace) {
        this.ignoreInputChange = true
        this.$nextTick(() => {
          this.ignoreInputChange = false
        })
      }
    },
    onEscapeKeyDown: function () {
      if (this.$refs.select.menu || this.$refs.select.dialog) {
        this.$refs.select.hidePopup()
        this.hideSearchInput()
      } else if (this.searchConfig.focus) {
        this.hideSearchInput()
      } else {
        this.blurField()
      }
    },
    hideSearchInput: function () {
      this.searchConfig.focus = false
      this.$nextTick(() => {
        if (this.$refs.select) { // После изменения значения может пропасть при перерисовке (?) внешнего компонента
          this.$refs.select.focus()
        }
      })
    },
    blurField: function () {
      this.$refs.select.blur()
    },
    onBlur: function () {
      if ((this.itemsList.length === 0 || this.searchConfig.focus) && this.inputValue) {
        this.emitCreateNewValue(this.inputValue, this.$refs.select.add, 'focusout')
      }

      this.searchConfig.focus = false

      // Сброс сохраненного значения внутреннего input
      this.inputValue = ''
    },
    onClick: function (event) {
      if (this.ignoreNextNativeClickEvent) {
        this.ignoreNextNativeClickEvent = false
        return
      }
      if (!this.readonly) {
        if (this.selectDisabled) {
          this.showSelectionDialog()
        } else {
          const targetClasses = event.target.classList
          if (!(targetClasses && targetClasses.length && (targetClasses[0] === 'q-btn' || targetClasses[0] === 'q-focus-helper'))) {
            this.searchConfig.focus = true

            this.$nextTick(() => {
              this.$refs.select.showPopup()

              if (targetClasses && targetClasses.length && targetClasses[0] === 'q-field__input') {
                const self = this
                this.$emit('input-value-started', function (inputValue) {
                  self.$refs.select.updateInputValue(inputValue)
                })
              }
            })
          }
        }
      }
    },
    onClear: function (event) {
      if (event) {
        event.preventDefault()
      }

      if (this.itemsList.length) {
        this.setValue([])
      }

      // Сброс сохраненного значения внутреннего input
      this.inputValue = ''
    },
    onShowSelectionDialog: function () {
      this.ignoreNextNativeClickEvent = true
      if (this.readonly) {
        return
      }
      this.showSelectionDialog()
    },
    showSelectionDialog: function () {
      this.selectedItems = this.itemsList.slice()
      this.selectedItemsIds = this.itemsList.map(item => this.getItemValue(item))
      this.selectionDialogOpened = true
    },
    onCancelSelection: function () {
      this.selectedItems = []
      this.selectedItemsIds = []
      this.closeSelectionDialog()
    },
    onItemSelected: function (item) {
      if (this.multiple) {
        const itemIndex = this.selectedItemsIds.indexOf(this.getItemValue(item))
        if (itemIndex === -1) {
          // Ищем среди старых значений
          const itemOld = this.itemsList.find(itemOld => itemOld[this.optionValue] === this.getItemValue(item))
          if (itemOld) {
            item = itemOld
          }
          this.selectedItemsIds.push(this.getItemValue(item))
          this.selectedItems.push(item)
        } else {
          this.selectedItemsIds.splice(itemIndex, 1)
          this.selectedItems.splice(itemIndex, 1)
        }
      } else {
        this.onItemsSelected(item ? [item] : [])
      }
      this.$emit('selected-items', this.selectedItems)
    },
    onItemsSelected: function (items) {
      this.selectedItems = items
    },
    onClearSelection: function () {
      this.selectedItemsIds = []
      this.selectedItems = []
    },
    onSelectAllItems: function () {
      if (this.searchConfig.store) {
        const store = this.searchConfig.store
        if (!store.proxy || store.fullReadable) {
          this.selectedItems = JSON.parse(JSON.stringify(store._itemsFiltered))
          this.selectedItemsIds = JSON.parse(JSON.stringify(store._itemsFiltered.map(item => this.getItemValue(item))))
        } else if (store && store.proxy && store.proxy.selectAll) {
          this.$q.loading.show({ spinnerColor: 'blue-11' })
          store.proxy.selectAll.itemsFn(store.proxy.searchValue, this.optionValue, this.optionLabel)
            .then(result => {
              this.selectedItems = result
              this.selectedItemsIds = result.map(item => this.getItemValue(item))
            }).finally(() => {
              this.$q.loading.hide()
            })
        }
      }
    },
    onSaveSelection: function () {
      if (this.confirmSaveSelection && this.confirmSaveSelection.need) {
        this.$d_ask({
          callback: (data, action) => {
            if (action === 'ok') {
              this.saveSelection()
            }
          },
          header: 'Cохранить выбор?',
          warning: this.confirmSaveSelection.warning || '',
          buttons: {
            ok: 'Сохранить',
            no: 'Отмена'
          }
        })
      } else {
        this.saveSelection()
      }
    },
    saveSelection: function () {
      this.setValue(this.selectedItems)
      this.closeSelectionDialog()
    },
    closeSelectionDialog: function () {
      this.selectionDialogOpened = false

      const store = this.searchConfig.store
      if (store && store.proxy && store.proxy.searchValue) {
        store.proxy.searchValue = null
        this.searchConfig.reset()
      }

      this.$nextTick(() => {
        this.blurField()
      })
      this.$emit('close-selection')
    },
    onCreateNewValue (val, done) {
      this.emitCreateNewValue(val, done, 'keydown')
    },
    emitCreateNewValue (val, done, eventType) {
      this.$emit('new-value', val, done, eventType)
    }
  }
}
